import { render, staticRenderFns } from "./emoji-picker-dialog.vue?vue&type=template&id=e50ee44c&scoped=true"
import script from "./emoji-picker-dialog.vue?vue&type=script&lang=ts"
export * from "./emoji-picker-dialog.vue?vue&type=script&lang=ts"
import style0 from "./style/index.scss?vue&type=style&index=0&id=e50ee44c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50ee44c",
  null
  
)

export default component.exports